export const SLM_CORE = [
  'Μόνιμη συνεργασία',
  'Σταθερό ωράριο',
  'Εβδομαδιαίο πρόγραμμα',
  'Εταιρικό όχημα',
  'Αποζημίωση καυσίμων',
  'Αποζημίωση κινητού',
  'Full Εξοπλισμός',
  'Bonus επιβράβευσης',
  'Tips'
];

export const SLM_EXTRA = [
  'Αθήνα και Θεσσαλονίκη',
  'Έξτρα Εισόδημα',
  'Ορισμός έως και μία ώρα πριν',
  'Αποζημίωση καυσίμων',
  'Αποζημίωση κινητού',
  'Βασικός Εξοπλισμός',
  'Bonus επιβράβευσης',
  'Tips'
];

export const WAREHOUSE_CORE = [
  'Μόνιμη συνεργασία',
  'Ευέλικτο πρόγραμμα εργασίας',
  'Παπούτσια εργασίας',
  'Εxtra Benefits',
  'Eυχάριστο Κλίμα'
];

export const WAREHOUSE_EXTRA = [
  'Έξτρα Εισόδημα',
  'Ορισμός έως και μία ώρα πριν',
  'Ευέλικτο πρόγραμμα εργασίας',
  'Παπούτσια εργασίας',
  'Eυχάριστο Κλίμα'
];
